import { Text } from '@backyard-ui/core';

export default function DisabledDisclaimer() {
  return (
    <Text size="sm" color="gray-500">
      <strong>Atenção!</strong> Este produto não está disponível para entrega e
      por isso a calculadora de frete está desativada.
    </Text>
  );
}
